import * as t from "io-ts";
import { decode } from "io-ts-promise";
import { equipmentDepotT, equipmentDepotsT } from "dora-contracts";

export type EquipmentDepot = t.TypeOf<typeof equipmentDepotT>;

/** Body of POST /api/equipment/depots. */
export type BaseEquipmentDepot = Omit<EquipmentDepot, "id" | "archived">;

/** Body of PUT /api/equipment/depots/:id. */
export type UpdateEquipmentDepot = BaseEquipmentDepot & { id: string };

export const decodeEquipmentDepot = decode(equipmentDepotT);
export const decodeEquipmentDepots = decode(equipmentDepotsT);
